module.exports = __webpack_public_path__ + "static/media/docs-es.b83ad58f.jpg";